import { api } from '../../lib/api.ts';

export interface ComparisonItem {
  id: string;
  name: string;
  qty: number;
  unit: string;
}

export interface ComparisonResponse {
  responseId: string;
  vendorId: string;
  vendorName: string;
  submittedAt: string;
  complete: boolean;
  total: number;
  lines: Record<string, number | null>;
}

export interface Comparison {
  items: ComparisonItem[];
  responses: ComparisonResponse[];
  lowestPerItem: Record<string, number | null>;
  lowestCompleteTotal: number | null;
  winnerResponseId: string | null;
  awardPaid: boolean;
  awardPaidAt: string | null;
  awardSentToFinanceAt: string | null;
  goodsReceivedAt: string | null;
  invoiceConfirmedAt: string | null;
}

export type PoDocKind = 'PO' | 'OTHER';

export interface PoUpload {
  id: string;
  kind: PoDocKind;
  fileName: string;
  mime: string;
  size: number;
  sortOrder: number;
  uploadedAt: string;
}

export const comparisonApi = {
  get: (requestId: string) =>
    api.get<Comparison>(`/requests/${requestId}/comparison`).then((r) => r.data),
  award: (requestId: string, winningResponseId: string) =>
    api
      .post<{ message: string }>(`/requests/${requestId}/award`, { winningResponseId })
      .then((r) => r.data),
  setPaid: (requestId: string, paid: boolean) =>
    api
      .patch<{ award: { paid: boolean; paidAt: string | null } }>(`/requests/${requestId}/award/paid`, { paid })
      .then((r) => r.data.award),
  goodsReceived: (requestId: string) =>
    api
      .post<{ award: unknown }>(`/requests/${requestId}/award/goods-received`)
      .then((r) => r.data),
  resendInvoiceLink: (requestId: string) =>
    api
      .post<{ award: unknown }>(`/requests/${requestId}/award/resend-invoice-link`)
      .then((r) => r.data),
  // ── Purchase Orders attached before the bill goes to Finance ──────────────
  listPoUploads: (requestId: string) =>
    api.get<{ uploads: PoUpload[] }>(`/requests/${requestId}/award/po`).then((r) => r.data.uploads),
  uploadPo: (requestId: string, body: { kind?: PoDocKind; fileName: string; mime: string; dataBase64: string }) =>
    api.post<{ upload: PoUpload }>(`/requests/${requestId}/award/po`, body).then((r) => r.data.upload),
  deletePo: (requestId: string, poId: string) =>
    api.delete(`/requests/${requestId}/award/po/${poId}`).then(() => undefined),
  paymentPackageUrl: (requestId: string) => `/requests/${requestId}/payment-package.pdf`,
};
